import { render, staticRenderFns } from "./request-to-employee.vue?vue&type=template&id=0143b3b0&scoped=true"
import script from "./request-to-employee.vue?vue&type=script&lang=js"
export * from "./request-to-employee.vue?vue&type=script&lang=js"
import style0 from "./request-to-employee.vue?vue&type=style&index=0&id=0143b3b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0143b3b0",
  null
  
)

export default component.exports